/**
 * Domain-specific event types for the recruiting system
 * Following Domain-Driven Design principles
 */
export var AppEventType;
(function (AppEventType) {
    AppEventType["USERDATA_UPDATED"] = "userData:updated";
    // Job Events
    AppEventType["JOBS_LOADED"] = "jobs:loaded";
    AppEventType["JOB_CREATED"] = "job:created";
    AppEventType["JOB_UPDATED"] = "job:updated";
    AppEventType["JOB_DELETED"] = "job:deleted";
    // Candidate Events
    AppEventType["CANDIDATES_LOADED"] = "candidates:loaded";
    AppEventType["CANDIDATE_CREATED"] = "candidate:created";
    AppEventType["CANDIDATE_UPDATED"] = "candidate:updated";
    AppEventType["CANDIDATE_DELETED"] = "candidate:deleted";
    AppEventType["CANDIDATE_SCORED"] = "candidate:scored";
    AppEventType["CANDIDATE_INTERVIEWED"] = "candidate:interviewed";
    AppEventType["CANDIDATE_HIRED"] = "candidate:hired";
    AppEventType["CANDIDATE_REJECTED"] = "candidate:rejected";
    // Calendar Events
    AppEventType["CALENDAR_EVENTS_LOADED"] = "calendar:events:loaded";
    AppEventType["CALENDAR_EVENT_CREATED"] = "calendar:event:created";
    AppEventType["CALENDAR_EVENT_UPDATED"] = "calendar:event:updated";
    // Settings Events
    AppEventType["SETTINGS_LOADED"] = "settings:loaded";
    AppEventType["SETTINGS_UPDATED"] = "settings:updated";
    // Authentication Events
    AppEventType["USER_LOGGED_IN"] = "auth:user:logged_in";
    AppEventType["USER_LOGGED_OUT"] = "auth:user:logged_out";
    AppEventType["USER_UPDATED"] = "auth:user:updated";
    // Chat Events
    AppEventType["CHAT_MESSAGE_RECEIVED"] = "chat:message:received";
    // Scoring Progress Events
    AppEventType["SCORING_RETRY"] = "scoring:retry";
    // Anti-ghosting follow-up events
    AppEventType["SCHEDULED_MESSAGE_UPDATED"] = "scheduledMessage:updated";
    /** Bulk variant fired when many scheduled messages change atomically. */
    AppEventType["SCHEDULED_MESSAGES_UPDATED"] = "scheduledMessages:updated";
    /** Admin hard-delete — drop the row from any visible table. */
    AppEventType["SCHEDULED_MESSAGE_DELETED"] = "scheduledMessage:deleted";
    // System Events
    AppEventType["INITIAL_DATA_LOADED"] = "system:initial_data:loaded";
    AppEventType["ERROR_OCCURRED"] = "system:error";
    AppEventType["LOADING_STATE_CHANGED"] = "system:loading:changed";
    // Organization Events
    AppEventType["ORG_UPDATED"] = "org:updated";
    AppEventType["ORG_INVITATIONS_UPDATED"] = "org:invitations:updated";
    /** Teammates' communication settings arrived (their jobs follow them). */
    AppEventType["TEAM_COMMUNICATIONS_LOADED"] = "org:communications:loaded";
    /** The workspace's communication report counters loaded or grew (`App.getCommMetrics`). */
    AppEventType["COMM_METRICS_UPDATED"] = "org:commMetrics:updated";
    /** The workspace's Meta Lead Ads connection, forms or leads loaded or changed (`App.getMetaLeadAds`). */
    AppEventType["META_LEAD_ADS_UPDATED"] = "integrations:metaLeadAds:updated";
    // Activity Feed Events
    AppEventType["ACTIVITY_UPDATED"] = "activity:updated";
})(AppEventType || (AppEventType = {}));
